// Mock data for BS IMPORT AUTO - Sports car import & brokerage
// NOTE: All data here is MOCKED (frontend only). Will be replaced by backend later.

export const CONTACT = {
  phone: "+33 6 67 09 91 22",
  phoneRaw: "0667099122",
  email: "bsimportauto@gmail.com",
  whatsapp: "https://wa.me/33667099122",
  instagram: "https://www.instagram.com/bs_import_auto/",
  tiktok: "https://www.tiktok.com/@bsimportauto",
};

export const IMAGES = {
  heroSupercars:
    "https://images.unsplash.com/photo-1617814086906-d847a8bc6fca?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1Mjh8MHwxfHNlYXJjaHwxfHxzdXBlcmNhciUyMGRhcmt8ZW58MHx8fHwxNzg0NjI1ODIzfDA&ixlib=rb-4.1.0&q=85",
  darkGarage:
    "https://images.unsplash.com/photo-1720080829677-4a3156adddbd?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1Mjh8MHwxfHNlYXJjaHw0fHxzdXBlcmNhciUyMGRhcmt8ZW58MHx8fHwxNzg0NjI1ODIzfDA&ixlib=rb-4.1.0&q=85",
  orangeLambo:
    "https://images.unsplash.com/photo-1532581140115-3e355d1ed1de?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDk1Nzd8MHwxfHNlYXJjaHwyfHxsdXh1cnklMjBzcG9ydHMlMjBjYXJ8ZW58MHx8fHwxNzg0NjI1ODIzfDA&ixlib=rb-4.1.0&q=85",
  redAmgGt:
    "https://images.unsplash.com/photo-1489686995744-f47e995ffe61?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDk1Nzd8MHwxfHNlYXJjaHw0fHxsdXh1cnklMjBzcG9ydHMlMjBjYXJ8ZW58MHx8fHwxNzg0NjI1ODIzfDA&ixlib=rb-4.1.0&q=85",
  orangePorsche:
    "https://images.unsplash.com/photo-1580881647059-923632b8fd75?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1NTJ8MHwxfHNlYXJjaHwyfHxnZXJtYW4lMjBwZXJmb3JtYW5jZSUyMGNhcnxlbnwwfHx8fDE3ODQ2MjU4MjJ8MA&ixlib=rb-4.1.0&q=85",
  redBmwRoad:
    "https://images.pexels.com/photos/11921988/pexels-photo-11921988.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
  ferrariInterior:
    "https://images.pexels.com/photos/34243853/pexels-photo-34243853.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
  blackSedan:
    "https://images.unsplash.com/photo-1485291571150-772bcfc10da5?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDk1Nzd8MHwxfHNlYXJjaHwxfHxsdXh1cnklMjBzcG9ydHMlMjBjYXJ8ZW58MHx8fHwxNzg0NjI1ODIzfDA&ixlib=rb-4.1.0&q=85",
};

export const NAV_LINKS = [
  { label: "Accueil", href: "#hero" },
  { label: "Services", href: "#services" },
  { label: "Garage", href: "#garage" },
  { label: "Formations", href: "#formations" },
  { label: "À propos", href: "#about" },
  { label: "Avis", href: "#avis" },
  { label: "Contact", href: "#contact" },
];

export const SERVICES = [
  {
    id: "courtage",
    title: "Service de courtage complet",
    price: "990 €",
    priceValue: 990,
    tagline: "Clé en main",
    description:
      "Un accompagnement clé en main, de la recherche à l'immatriculation : sourcing du véhicule adapté à vos besoins et à votre budget, négociation, inspection technique et prise en charge des démarches administratives d'immatriculation (hors coût de la carte grise). La livraison n'est pas incluse : elle est proposée en bonus, sur devis.",
    features: [
      "Recherche personnalisée selon vos critères",
      "Négociation et inspection technique",
      "Démarches administratives d'immatriculation (hors coût de la carte grise)",
      "Livraison en bonus, sur devis — sinon, accompagnement pour une récupération autonome",
    ],
    image:
      "https://images.unsplash.com/photo-1489686995744-f47e995ffe61?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDk1Nzd8MHwxfHNlYXJjaHw0fHxsdXh1cnklMjBzcG9ydHMlMjBjYXJ8ZW58MHx8fHwxNzg0NjI1ODIzfDA&ixlib=rb-4.1.0&q=85",
    highlight: true,
  },
  {
    id: "recherche",
    title: "Recherche de véhicule",
    price: "Sur devis",
    priceValue: 0,
    tagline: "Sourcing expert",
    description:
      "Vous savez ce que vous voulez ? Je déniche la perle rare en Allemagne, Italie et Belgique. Accès à un aux meilleures affaires du marché.",
    features: [
      "Accès réseau vendeurs premium",
      "Sélection selon votre budget",
      "Rapport détaillé de chaque véhicule",
      "Comparatif des meilleures offres",
    ],
    image:
      "https://images.unsplash.com/photo-1580881647059-923632b8fd75?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1NTJ8MHwxfHNlYXJjaHwyfHxnZXJtYW4lMjBwZXJmb3JtYW5jZSUyMGNhcnxlbnwwfHx8fDE3ODQ2MjU4MjJ8MA&ixlib=rb-4.1.0&q=85",
    highlight: false,
  },
  {
    id: "immatriculation",
    title: "Immatriculation en France",
    price: "349 €",
    priceValue: 349,
    tagline: "Carte grise",
    description:
      "Import déjà réalisé ? Je prends en charge l'ensemble des démarches administratives d'immatriculation : quitus fiscal, certificat de conformité (COC) et constitution complète du dossier. Le coût de la carte grise reste à votre charge.",
    features: [
      "Quitus fiscal & démarches douanières",
      "Certificat de conformité (COC)",
      "Constitution complète du dossier",
      "Coût de la carte grise non inclus (à votre charge)",
    ],
    image:
      "https://images.unsplash.com/photo-1720080829677-4a3156adddbd?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1Mjh8MHwxfHNlYXJjaHw0fHxzdXBlcmNhciUyMGRhcmt8ZW58MHx8fHwxNzg0NjI1ODIzfDA&ixlib=rb-4.1.0&q=85",
    highlight: false,
  },
  {
    id: "etude",
    title: "Étude d'un véhicule",
    price: "99 €",
    priceValue: 99,
    tagline: "Expertise",
    description:
      "Un véhicule vous intéresse ? J'analyse pour vous l'annonce, l'historique, les coûts d'import et la rentabilité de l'opération. Un avis d'expert avant de vous engager.",
    features: [
      "Analyse complète de l'annonce",
      "Vérification historique & kilométrage",
      "Estimation des coûts d'import",
      "Recommandation d'achat claire",
    ],
    image:
      "https://images.unsplash.com/photo-1485291571150-772bcfc10da5?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDk1Nzd8MHwxfHNlYXJjaHwxfHxsdXh1cnklMjBzcG9ydHMlMjBjYXJ8ZW58MHx8fHwxNzg0NjI1ODIzfDA&ixlib=rb-4.1.0&q=85",
    highlight: false,
  },
];

export const FORMATIONS = [
  {
    id: "pack1",
    name: "PACK 1",
    title: "Bien Acheter & Immatriculer sa Voiture",
    price: "199 €",
    description:
      "Apprenez à importer votre voiture comme un pro, quel que soit le modèle ou le budget. Toutes les étapes, les pièges à éviter et les astuces pour économiser des milliers d'euros.",
    modules: [
      "Trouver les meilleures affaires à l'étranger",
      "Négocier comme un professionnel",
      "Sécuriser son achat & son transport",
      "Réaliser soi-même son immatriculation",
    ],
    image:
      "https://images.unsplash.com/photo-1532581140115-3e355d1ed1de?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDk1Nzd8MHwxfHNlYXJjaHwyfHxsdXh1cnklMjBzcG9ydHMlMjBjYXJ8ZW58MHx8fHwxNzg0NjI1ODIzfDA&ixlib=rb-4.1.0&q=85",
  },
  {
    id: "pack2",
    name: "PACK 2",
    title: "Immatriculation Complète",
    price: "249 €",
    description:
      "La formation ultime pour maîtriser 100% des démarches administratives d'immatriculation d'un véhicule importé, de A à Z.",
    modules: [
      "Constituer un dossier béton",
      "Obtenir quitus fiscal & COC",
      "Gérer les cas complexes",
      "Accompagnement pas à pas",
    ],
    image:
      "https://images.pexels.com/photos/34243853/pexels-photo-34243853.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
  },
];

export const STATS = [
  { value: 40, suffix: "+", label: "Clients satisfaits" },
  { value: 3, suffix: "", label: "Pays sources" },
  { value: 100, suffix: "%", label: "Démarches gérées" },
  { value: 2025, suffix: "", label: "Depuis février" },
];

export const STEPS = [
  {
    num: "01",
    title: "Recherche",
    text: "Je sélectionne le véhicule idéal selon vos critères et votre budget.",
  },
  {
    num: "02",
    title: "Négociation",
    text: "Je négocie le meilleur prix et vérifie chaque détail technique du véhicule.",
  },
  {
    num: "03",
    title: "Importation",
    text: "Transport sécurisé depuis l'Allemagne, l'Italie ou la Belgique jusqu'à vous.",
  },
  {
    num: "04",
    title: "Immatriculation",
    text: "Je gère toutes les démarches administratives d'immatriculation (hors coût de la carte grise).",
  },
];

export const TESTIMONIALS = [
  {
    name: "Nicolas",
    city: "Paris",
    text: "Les formations sont très complètes et très bien présentées ! Merci encore !",
    rating: 5,
  },
  {
    name: "Julien",
    city: "Lyon",
    text: "J'ai importé mon Audi RS3 grâce à BS Import Auto. Service impeccable, économie de plus de 8000€. Je recommande à 100%.",
    rating: 5,
  },
  {
    name: "Marc",
    city: "Bordeaux",
    text: "Accompagnement au top du début à la fin. Mon break familial était livré et immatriculé sans que j'aie à lever le petit doigt.",
    rating: 5,
  },
  {
    name: "Sophie",
    city: "Marseille",
    text: "Professionnel, réactif et de très bon conseil. La recherche de véhicule a été rapide et efficace. Bravo !",
    rating: 5,
  },
];

export const BRANDS = [
  "VOLKSWAGEN",
  "RENAULT",
  "PEUGEOT",
  "AUDI",
  "BMW",
  "MERCEDES",
  "TESLA",
  "TOYOTA",
  "PORSCHE",
  "CITROËN",
];

export const GARAGE = [
  {
    brand: "Porsche",
    tagline: "Le premium allemand",
    src: "/videos/garage-porsche.mp4",
  },
  {
    brand: "BMW",
    tagline: "De la Série 1 à la M",
    src: "/videos/garage-bmw.mp4",
  },
  {
    brand: "Audi",
    tagline: "A1, A3, Q5, RS…",
    src: "/videos/garage-audi.mp4",
  },
  {
    brand: "Mercedes",
    tagline: "De la Classe A à l'AMG",
    src: "/videos/garage-amg.mp4",
  },
];
